define('BookingEngine/app-Passdetails/main',['./settings', "util", 'moment', '../app-BEBasket/module', '../../app-Gdpr/main', '../../app/ui/dialog', 'jqueryval', 'jqueryvalunob', 'sumoselect'],
    function (settings, util, moment, beBasket, gdpr, dialog) {
    return {
        isNullUndefEmpty: function (variable) {
            return (variable === null || variable === undefined || variable === '');
        },

        displayAdditionalPassengers: function (paxnr) {
            var isNullUndefEmpty = this.isNullUndefEmpty;
            //Check to make sure that we are activating the correct passenger after preferences have been provided
            var nr = parseInt(paxnr) + 1;
            var paxDisabled = $("#" + nr + ".passdisabled");
            var paxSummary = $("#" + nr + ".passsummary");
            var paxActive = $("#" + nr + ".passactive");

            if (!paxSummary.is(":visible") || $.trim(paxSummary.html()) == "") {
                paxActive.slideDown("slow", function () {
                    paxDisabled.hide();
                    $("#ActivePaxNumber").val(nr);
                    $("select").SumoSelect();
                    $("html, body").animate({ scrollTop: paxActive.offset().top - 10 }, "slow", "swing");
                });
            } else {
                $("html, body").animate({ scrollTop: $("#" + paxnr + ".passsummary").offset().top - 10 }, "slow", "swing");
            }

            AdlAddUpdateItem("pageName", "travel|purchase|passengerdetails|passenger" + nr);

            function adlPassDetails() {
                util.satelliteTrack("virtualPageViewTBJ");

                //after the tracking call set previous page name to this value
                //set a timeout to prevent it getting set before it's been read
                //also add it to local storage so that a page change picks up the correct value.  

                setTimeout(function () {
                    var prevpage = localStorage.getItem("previousPageName");

                    if (!isNullUndefEmpty(prevpage)) {
                        AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                    }

                    localStorage.setItem("previousPageName", "travel|purchase|passengerdetails|passenger" + nr);
                }, 999);

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlPassDetails, 250);
            }
        },

        bypassContinue: function (paxnr, callback) {
            var byPassContinuePaxNumber = $("#ByPassContinueOnPaxNumber").val();

            if (byPassContinuePaxNumber === paxnr) {
                AdlAddUpdateItem("BookingJourneyStep", "review");
                window.location.replace($("#continueurl").val());

                return null;
            }
            if (callback != undefined) {
                callback();
            }
        },

        enableContinue: function () {
            if ($('.passsummary.noshow').length == 0) {
                $('#disablecontinue').hide();
                $('#continue').show();
            }
        },

        resetGatekeeperQuestions: function (resetQuestions, paxNumber, questionNumber) {

            //Total reset
            if (resetQuestions) {
                var gatekeeperContainers = $("#gatekeeper" + paxNumber + " .gatekeeper-question");
                
                $.each(gatekeeperContainers, function (index, element) {
                    $(element).find("input").prop("checked", false);    
                    $(element).slideUp();
                });

                $("#gatekeeper" + paxNumber).slideUp()
                $('#gatekeeper-ineligible-container' + paxNumber).find("div.col-12").html("");
                return;
            }

            //Otherwise, just hide/reset the questions displayed after the current questionNumber
            var visibleGatekeeperContainers = $("#gatekeeper" + paxNumber + " .gatekeeper-question:visible");

            if (visibleGatekeeperContainers.length > questionNumber) {
                var filtered = visibleGatekeeperContainers.filter(function (index) {
                    return index > questionNumber - 1;
                });

                filtered.each(function (i, v) {
                    $(v).slideUp().find("input:checked").prop("checked", false);
                });
            }
        },

        resetMedicalConditions: function (paxNumber) {
            $("#Optin" + paxNumber).slideUp();
            var medicalConditionsContainer = $("#medicalCond" + paxNumber);
            medicalConditionsContainer.slideUp();
            medicalConditionsContainer.find("input:checked").prop("checked", false);
        },

        updateName: function (paxNumber) {
            var firstName = $('#txtFirstName' + paxNumber).val(),
                lastName = $('#txtLastName' + paxNumber).val();

            if (util.stringIsNullOrWhitespace(firstName) || util.stringIsNullOrWhitespace(lastName))
                return;

            var passengerSection = $('#passdet' + paxNumber);

            passengerSection.find("span.name-placeholder").each(function (index, element) {
                $(element).text(firstName + " " + lastName);
            })
        },


        setAddressLookUpErrorText: function (text) {
            var paxNo = paxNo = $('#ActivePaxNumber').val(),
                addressPicker = $('#AddressPicker' + paxNo);
            addressPicker.find('#AddressPostCodeErrorText').html(text).show();
            addressPicker.find('.elementHolder').addClass('errorHolder');
        },

        getAddressSummaries: function (paxNo, postCode) {
            var $thisModule = this;
            postCode = postCode.replace(/\s+/g, '').toUpperCase();

            if (!postCode.length || !$thisModule.postcodeRegexTest(postCode)) {
                $thisModule.setAddressLookUpErrorText('Please enter a valid postcode');
                return;
            }

            var findBtn = $('#AddressPicker' + paxNo).find('.FindAddressBtn');
            findBtn.addClass('disabled spinner');
            //Trigger Address Search
            //update loading text to display searching for address??
            $.post(settings.getAddressSummariesUrl, { postCode: postCode }, null)
                .done(function (data) {
                    if (data.length === 0) {
                        $thisModule.setAddressLookUpErrorText('Sorry but no address details were found.<br/>Please try again or enter your address manually');
                        return;
                    }

                    var addressList = $('#AddressSelectList' + paxNo);

                    //populate the address dropdown, show and set focus
                    addressList.empty().append($("<option></option>")
                            .attr("value", -1)
                            .text('Please Select Address'));

                    $.each(data, function (index, addressSummaries) {
                        //add full address to drop down
                        addressList.append($("<option></option>")
                                .attr("value", addressSummaries.token)
                                .text(addressSummaries.address));
                    });

                    $('#SelectAddressFrom' + paxNo).show();
                    $('#dvLookUpAddr' + paxNo).hide();
                    $('#AddressPicker' + paxNo + ' .FindAddressBtn').hide();
                    addressList.focus();

                    if ($('#AddressPicker' + paxNo).find('.SumoSelect').length > 0) {
                        addressList[0].sumo.reload();
                    } else {
                        addressList.SumoSelect();
                    };
                })
                .fail(function () {
                    $thisModule.setAddressLookUpErrorText('Sorry but no address details were found.<br/>Please try again or enter your address manually');
                }).always(function () {
                    findBtn.removeClass('disabled spinner');
                });
        },

        getFormattedAddress: function (token) {
            var $thisModule = this,
                paxNo = $('#ActivePaxNumber').val(),
                addressControl = $('#SelectAddressFrom' + paxNo);
            addressControl.find('.CaptionCont.SlectBox').addClass('d-none');
            addressControl.find('a.btn').removeClass('d-none');

            $.post(settings.getFormattedAddressUrl, { token: token }, null)
                .done(function (data) {
                    if (!data) {
                        $thisModule.setAddressLookUpErrorText('We\'ve encountered a problem wtih your address search.<br/>Please try again or enter your address manually');
                        $thisModule.resetAddressSelect(paxNo);
                        return;
                    }
                    $thisModule.populateAddressData(data);
                })
                .fail(function () {
                    $thisModulesetAddressLookUpErrorText('We\'ve encountered a problem wtih your address search.<br/>Please try again or enter your address manually');
                    $thisModule.resetAddressSelect(paxNo);
                    return;
                })
                .always(function () {
                    addressControl.find('.CaptionCont.SlectBox').removeClass('d-none');
                    addressControl.find('a.btn').addClass('d-none');
                });
        },

        resetAddressSelect: function (paxNo) {
            var addressPicker = $("#AddressPicker" + paxNo);
            addressPicker.find('#dvLookUpAddr' + paxNo).show(250);        
            addressPicker.find('#AddressSelectList' + paxNo).empty();
            addressPicker.find('#SelectAddressFrom' + paxNo).hide(250);
            addressPicker.find('.FindAddressBtn').show(250);
        },

        populateAddressData: function (formattedAddress) {  
            var $thisModule = this;
            if (!$thisModule.isNullUndefEmpty(formattedAddress)) {

                var paxNo = $('#ActivePaxNumber').val(),
                    $thisModule = this,
                    address1 = formattedAddress.address1.trim(),
                    address2 = formattedAddress.address2.trim(),
                    town = formattedAddress.town.trim(),
                    county = formattedAddress.county.trim(),
                    postcode = formattedAddress.postcode.trim(),
                    udprn = formattedAddress.udprn.trim(),
                    uprn = formattedAddress.uprn.trim(),
                    addressArray = [address1, address2, town, county, postcode],
                    fullAddressString = addressArray.filter(function (addressLine) {
                        return addressLine && addressLine.length > 0
                    });   

                //populate address fields
                $('#AddrLn1p' + paxNo).val(address1);
                $('#AddrLn2p' + paxNo).val(address2);
                $('#AddrTownp' + paxNo).val(town);
                $('#AddrCountyp' + paxNo).val(county);
                $('#AddrPostCodep' + paxNo).val(postcode);
                $('#PostCodep' + paxNo).val(postcode);             

                //update hidden fields
                $('#Address1p' + paxNo).val(address1);
                $('#Address2p' + paxNo).val(address2);
                $('#Townp' + paxNo).val(town);
                $('#Countyp' + paxNo).val(county);
                $('#hdnPostCodep' + paxNo).val(postcode);
                $('#Udprnp' + paxNo).val(udprn);
                $('#Uprnp' + paxNo).val(uprn);            

                $("#SelectAddressFrom" + paxNo).hide(250);
                $("#AddressPicker" + paxNo).hide(250);
                $("#SelectedAddressText" + paxNo).text(fullAddressString.join(", "));
                $("#EditCompletedAddressLink" + paxNo).show();
                $("#CompletedAddressDiv" + paxNo).show(500);

                ////if the passenger Nr is 1 set the same address for other passengers too
                if (paxNo == "1") {
                    $('p.SelectedAddress').each(function () {
                        var passno = parseInt($(this).data('paxno')),
                            hasNoSummary = $("#address-summary-" + passno).length === 0;
                        if (passno > 1 && hasNoSummary) {
                            $(this).text(fullAddressString);
                            $('#Address1p' + passno).val(address1);
                            $('#Address2p' + passno).val(address2);
                            $('#Townp' + passno).val(town);
                            $('#Countyp' + passno).val(county);
                            $('#hdnPostCodep' + passno).val(postcode);
                            $('#Udprnp' + passno).val(udprn);
                            $('#Uprnp' + passno).val(uprn);
                            $("#AddressPicker" + passno).hide();
                            $("#CompletedAddressDiv" + passno).show();
                            $("#CompletedAddressDiv" + passno).removeClass("noshow");
                        }
                    });
                }
            }
        },

        postcodeRegexTest: function (value) {
            var postcodeRegex = new RegExp('^(GIR 0AA|[A-PR-UWYZa-pr-uwyz]([0-9]{1,2}|([A-HIK-Ya-hik-y][0-9](|[0-9]|[ABEHMNPRVWXYabehmnprvwxy]))|[0-9][A-HJKSTUWa-hjkstuw]) ?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$');
            return postcodeRegex.test(value);
        },

        run: function () {
            var thisModule = this,
                currentDialog;

            var summary = $(settings.container);
            if (summary.length === 0) {
                window.log('Passenger details will not be available.');
                return;
            }

            beBasket.updateBasket();

            progress = function () {
                if ($(window).width() > 768) {
                    $('#yourHoliday').addClass('current');
                }
            }

            progress();

            $(window).on("resize", function (e) {
                progress();
            });

            // Upper-cases passenger names.  TODO- get this into the new JS standards.
            $('.properName').blur(function () {
                var s = $(this).val(),
                    paxNr = $('#ActivePaxNumber').val(),
                    out = "";

                if (s.length > 0) {
                    var c = true;
                    for (var i = 0; i < s.length; i++) {
                        var t = s.substring(i, i + 1).toUpperCase();

                        cmp = "ABCDEFGHIJKLMNOPQRSTUVWXYZ'";
                        if (cmp.indexOf(t) < 0) {
                            c = true;
                        } else {
                            if (c) {
                                c = false;
                            } else {
                                t = t.toLowerCase();
                            }
                        }

                        if (i > 1) {
                            temp = s.substring(i - 2, i).toUpperCase();

                            if ((temp == "MC") || (temp == "O'")) {
                                t = t.toUpperCase();
                            }
                            cmp = " II V X";
                            roman = "IVX";
                            roman2 = "IVX ";

                            if (cmp.indexOf(temp) >= 0 && roman.indexOf(t.toUpperCase()) >= 0 && roman2.indexOf(s.substring(i + 1, i + 2).toUpperCase()) >= 0) {
                                t = t.toUpperCase();
                            }
                        }

                        if (i > 2) {
                            temp = s.substring(i - 3, i).toUpperCase();

                            if ((temp == "MAC") || (temp == "VAN")) {
                                t = t.toUpperCase();
                            }

                            if ((temp == " XI" || temp == " VI" || temp == " XX" || temp == "XV") && (t.toUpperCase() == "I" || t.toUpperCase() == "V" || t.toUpperCase() == "X")) {
                                t = t.toUpperCase();
                            }
                        }
                        out += t;
                    }
                    $(this).val(out);
                }
                thisModule.updateName(paxNr);
                return true;
            });

            // When the insurance Options change
            $(".insOptions input:radio").change(function () {
                var $this = $(this),
                    radioStyled = $this.closest(".radioStyled");

                if (radioStyled.hasClass("disabled")) {
                    return;
                }

                var insOpt = $this.val().toLowerCase(),
                    paxNr = $('#ActivePaxNumber').val(),
                    optInContainer = $("#Optin" + paxNr),
                    optOutContainer = $("#Optout" + paxNr),
                    isOver18MonthsDeparture = $("#medicalCond" + paxNr).data("over18months") === "True",
                    gatekeeperContainer = $("#gatekeeper" + paxNr);

                if (insOpt === "true") {
                    optOutContainer.hide();
                    if (isOver18MonthsDeparture) {
                        $('#MedicalConditionNo' + paxNr).prop("checked", true);
                        optInContainer.slideDown();
                    } else {
                        gatekeeperContainer.find(".gatekeeper-question[data-question-number='1']").show();
                        gatekeeperContainer.slideDown();
                    }                   
                } else {
                    optInContainer.hide();

                    if (!isOver18MonthsDeparture) {
                        gatekeeperContainer.slideUp();
                        thisModule.resetGatekeeperQuestions(true, paxNr, null);
                    }

                    optOutContainer.show();
                    thisModule.resetMedicalConditions(paxNr);
                }
            });

            $(".gatekeeper-questions input:radio").change(function () {

                var $this = $(this),
                    paxNr = $('#ActivePaxNumber').val(),
                    gatekeeperContainer = $("#gatekeeper" + paxNr),
                    ineligibleTextContainer = $('#gatekeeper-ineligible-container' + paxNr),
                    approvedState = $this.data("approval"),
                    questionId = $this.data("question-number"),
                    parsedQuestionNumber = parseInt(questionId),
                    optInContainer = $("#Optin" + paxNr),
                    medicalConditionsContainer = $("#medicalCond" + paxNr);

                if (approvedState) {
                    ineligibleTextContainer.slideUp();
                    ineligibleTextContainer.find("div.col-12").html("");
                    var nextQuestion = gatekeeperContainer.find('div[data-question-number="' + (parsedQuestionNumber + 1) + '"]');
                    nextQuestion.slideDown();
                } else {
                    var ineligibleText = $this.data("ineligible-text");
                    ineligibleTextContainer.find("div.col-12").html(ineligibleText);
                    thisModule.resetGatekeeperQuestions(false, paxNr, parsedQuestionNumber);
                    thisModule.resetMedicalConditions(paxNr);
                    ineligibleTextContainer.slideDown();
                    return;
                }

                var completedGatekeeperControls = gatekeeperContainer.find("input:checked");

                if (completedGatekeeperControls.length < 6)
                    return;

                var gatekeeperPasses = [];                    

                $.each(completedGatekeeperControls, function (index, element) {
                    gatekeeperPasses.push($(element).data("approval"));
                });

                var passes = gatekeeperPasses.filter(function (pass) {
                        return Boolean(pass) == true;
                    }),
                    dontknows = completedGatekeeperControls.filter(function (index, element) {
                        return $(element).val().toLowerCase() === "dontknow";
                    });

                //if all 6 questions answered and positive, show insurance med dec question
                if (passes.length == 6) {                            
                    //If at least 1 gatekeeper is dontknow, set medical conditions to dontknow too.
                    var atLeastOneDontKnow = dontknows.length > 0;
                    $("#MedicalConditionYes" + paxNr).prop("disabled", atLeastOneDontKnow);
                    $("#MedicalConditionNo" + paxNr).prop("disabled", atLeastOneDontKnow);
                    $("#MedicalCondition" + paxNr).prop("checked", atLeastOneDontKnow);

                    atLeastOneDontKnow 
                        ? $("#medText" + paxNr).show().find("#medTextDontKnow" + paxNr).show()
                        : $("#medText" + paxNr).hide().find("#medTextDontKnow" + paxNr).hide();
  
                    medicalConditionsContainer.slideDown();
                    optInContainer.slideDown();
                }
            });

            //when the medical conditions change
            $('.medOptions input:radio').change(function () {
                var medOpt = $(this).val().toLowerCase(),
                    paxNr = $('#ActivePaxNumber').val();

                if (medOpt == "no") {
                    $('#medText' + paxNr).hide();
                } else {
                    $('#medText' + paxNr).show();

                    if (medOpt == "yes") {
                        $('#medTextDontKnow' + paxNr).hide();
                        $('#medTextYes' + paxNr).show();
                    } else {
                        $('#medTextYes' + paxNr).hide();
                        $('#medTextDontKnow' + paxNr).show();
                    }
                }
            });

            $(".assistanceOptions input:radio").on("change", function () {
                var passengerNumber = $('#ActivePaxNumber').val();
                var euAssist = $("#euAssist" + passengerNumber);
                var musterAssist = $("#musterAssist" + passengerNumber);

                if ($(this).val().toLowerCase() === "true") {
                    var showEuAssist = $("#ShowEuAssist").val().toLowerCase() === "true";
                    var showMusterAssist = $("#ShowMusterAssist").val().toLowerCase() === "true";

                    if (showEuAssist) {
                        euAssist.show();
                    }

                    if (showMusterAssist) {
                        musterAssist.show();
                    }
                } else {
                    euAssist.hide();
                    musterAssist.hide();
                }
            });

            $(".passactive").on("click", ".assistanceOptions input", function () {
                var paxNr = $("#ActivePaxNumber").val();
                var musterAssistanceHelpText = $("#musterAssistanceHelpText" + paxNr);

                if ($(this).val === "true") {
                    musterAssistanceHelpText.slideDown();
                } else {
                    musterAssistanceHelpText.slideUp();
                }
            });

            //Show/Hide passport details
            $('.passportDetailSection').on('click', function () {
                var paxnr = $('#ActivePaxNumber').val();
                $('.passportDetailsInfo' + paxnr).toggle();
                //GB value to top of dropdowns.
                $('#SelectedCountry' + paxnr + ' option[value="GB"]').insertBefore('#SelectedCountry' + paxnr + ' option').eq(1);
                $('#SelectedNationality' + paxnr + ' option[value="GB"]').insertBefore('#SelectedNationality' + paxnr + ' option').eq(1);
            });

            //validate trade dropdowns if they exist
            $('.passactive').on("change", '.countrySelect', function () {
                var paxnr = $('#ActivePaxNumber').val();
                validateDropdowns($('#SelectedCountry' + paxnr), $('#issueCountryval' + paxnr));
            });
            $('.passactive').on("change", '.nationalitySelect', function () {
                var paxnr = $('#ActivePaxNumber').val();
                validateDropdowns($('#SelectedNationality' + paxnr), $('#nationalityVal' + paxnr));
            });

            //validate selectTitle
            $('.passactive').on("change", '.titleSelect', function () {
                var paxnr = $('#ActivePaxNumber').val();
                validateDropdowns($('#SelectedTitle' + paxnr), $('#titleval' + paxnr));
            });

            function validateDropdowns(elementName, validationClassName, validationCheck) {
                if (elementName.val() == "" || elementName.val() == "01/01/0001" && validationCheck != "noneedtocheck") {
                    elementName.removeClass('valid');
                    elementName.parent().removeClass('valid');
                    elementName.addClass('input-validation-error');
                    validationClassName.removeClass('noshow');
                    return false;
                } else {
                    elementName.removeClass('input-validation-error');
                    elementName.parent().closest('.elementHolder').removeClass('errorHolder');
                    elementName.addClass('valid');
                    elementName.parent().addClass('valid');
                    validationClassName.addClass('noshow');
                }
                return true;
            }

            //Optional field val
            $('.midname').on('blur', function () {
                var middlename = $(this).val();

                if (middlename.length > 0) {
                    var alphaCharsRE = /^[a-zA-Z- ]*$/; //a-z, hyphen and space
                    var passFail = alphaCharsRE.test(middlename);

                    if (passFail == false) {
                        $(this).removeClass("valid").addClass("input-validation-error");
                        $(this).closest('.element').removeClass('valid');
                        $(this).next('.midval').removeClass('noshow');
                    } else {
                        $(this).removeClass("input-validation-error").addClass("valid");
                        $(this).parent().removeClass("errorHolder");
                        $(this).closest('.element').addClass('valid');
                        $(this).next('.midval').addClass('noshow');
                    }
                } else {
                    $(this).next('.midval').addClass('noshow');
                }
            });

            $('.alttele').on('blur', function () {
                var alttel = $(this).val();

                if (alttel.length > 0) {
                    var numericCharsRE = /^[0-9]*$/; //0-9
                    var passFail = numericCharsRE.test(alttel);

                    if (passFail == false) {
                        $(this).removeClass("valid").addClass("input-validation-error");
                        $(this).closest('.element').removeClass('valid');
                        $(this).next('.atltelval').removeClass('noshow');
                    } else {
                        $(this).removeClass("input-validation-error").addClass("valid");
                        $(this).parent().removeClass("errorHolder");
                        $(this).closest('.element').addClass('valid');
                        $(this).next('.atltelval').addClass('noshow');
                    }
                } else {
                    $(this).next('.atltelval').addClass('noshow');
                }
            });

            $(".updatepass").on("click", function (event) {
                event.preventDefault();

                var $this = $(this);
                var noOfPax = $('#NoofPax').val();
                var paxnr = $('#ActivePaxNumber').val();
                var currentForm = $('#passdet' + paxnr);
                var submiturl = settings.submiturl + 'UpdatePassenger';

                if (paxnr == 1) {
                    submiturl = settings.submiturl + 'UpdateLeadPassenger';
                }

                var isDOBvalPass = IsDOBValid(paxnr);
                var isTitlevalPass = validateDropdowns($('#SelectedTitle' + paxnr), $('#titleval' + paxnr));

                if (isDOBvalPass === false || isTitlevalPass === false) {
                    //get the form and do an unobtrusive validation
                    $('#passdet' + paxnr).valid();
                    slideToErrorSummary(paxnr);

                    return null;
                } else {
                    //get the form and do an unobtrusive validation
                    var isformvalid = $('#passdet' + paxnr).valid();
                }

                //Trade agent.
                if ($('#IsAuthenticatedTradeAgent').val() == "True") {
                    $('.addressHelperText').hide();

                    //Check if any of the passport fields have a value ignoring the default.
                    var passportFields = ['#passportNumber', '#SelectedCountry', '#SelectedNationality', '#issueDate', '#expiryDate'];
                    var anyPassportFieldValues = [];

                    $(passportFields).each(function (id, value) {
                        $(value + paxnr).val() && $(value + paxnr).val() != "01/01/0001" ? anyPassportFieldValues.push(1) : anyPassportFieldValues.push(0);
                    });

                    var passportFieldsHaveValue = $.inArray(1, anyPassportFieldValues) !== -1;
                    //If passportFieldsHaveValue is true.
                    if (passportFieldsHaveValue == true) {
                        $('#ShowEnterPassportDetails').val('False');
                        var isissueCountryValPass = validateDropdowns($('#SelectedCountry' + paxnr), $('#issueCountryval' + paxnr)),
                            isnationalityValPass = validateDropdowns($('#SelectedNationality' + paxnr), $('#nationalityVal' + paxnr)),
                            isPassportnumberValPass = validateDropdowns($('#passportNumber' + paxnr), $('#passportNumberVal' + paxnr)),
                            isIssueValPass = validateDropdowns($('#issueDate' + paxnr), $('#issueDateVal' + paxnr)),
                            isExpiryValPass = validateDropdowns($('#expiryDate' + paxnr), $('#expiryDateVal' + paxnr));
                        //Fields are now required add attr.
                        attrRequired(passportFields + paxnr, "add");
                        //Check that all fields are valid and have a value.
                        if (isissueCountryValPass == true && isnationalityValPass == true && isPassportnumberValPass == true && isIssueValPass == true && isExpiryValPass == true) {
                            //Passport details have been entered and are valid.
                            $('#ShowEnterPassportDetails').val('True');
                            IsIssueDateValid(paxnr);
                            IsExpiryDateValid(paxnr);
                            $('#passdet' + paxnr).valid();
                        } else {
                            //passport details entered but not completed.
                            $('#passdet' + paxnr).valid();
                            slideToErrorSummary(paxnr);
                            return null;
                        }
                    } else {
                        //No passport details have been entered.
                        $('#ShowEnterPassportDetails').val('False');

                        IsIssueDateValid(paxnr);
                        IsExpiryDateValid(paxnr);

                        attrRequired(passportFields + paxnr, "remove");
                        $('#passdet' + paxnr).valid();
                    }
                }

                //Add or remove required attr - passport details.
                function attrRequired(passportfields, addRemove) {
                    $(passportfields).each(function (id, value) {
                        if (addRemove == "add") {
                            $(value).attr("data-val-required");
                        } else if (addRemove == "remove") {
                            $(value).removeAttr("data-val-required");
                        }
                    });
                }

                //if there are no errors do an ajax post to controller
                if (isformvalid) {
                    var insuranceOptions = currentForm.find(".insOptions");

                    if (insuranceOptions.length > 0) {
                        var disableInsuranceOptions = $this.data("disable-insurance-options").toLowerCase();

                        if (disableInsuranceOptions === "true") {
                            var insOptValue = insuranceOptions.find("input:radio:checked").val();

                            if (insOptValue && insOptValue.toLowerCase() === "false") {
                                insuranceOptions.addClass("disabled");
                            }
                        }
                    }

                    AdlAddUpdateItem("BookingJourneyStep", "passenger" + paxnr);

                    var loadingDialog = dialog.show('Saving passenger details...', null, { noClose: true }, false, ['loader']);

                    var request = $.ajax({
                        url: submiturl,
                        type: "POST",
                        data: currentForm.serialize(),
                        cache: false
                    });

                    request.done(function (data, status, xhr) {
                        var ct = xhr.getResponseHeader("content-type") || "";

                        if (ct.indexOf('json') > -1) {
                            if (data.redirectToErrorPage) {
                                var errorpage = $('#errorurl').val();
                                window.location.replace(errorpage);
                                return null;
                            }

                            var valsumm = '#valsummary' + paxnr;
                            $(valsumm).empty();
                            $(valsumm).removeClass('validation-summary-valid').addClass('validation-summary-errors');
                            $(valsumm).append("<ul>");

                            $.each(data.errors, function (index, obj) {
                                $(valsumm + ' ul').append("<li>" + obj.errorText + "</li>");
                            });

                            $(valsumm).show();
                            slideToErrorSummary(paxnr);

                            // hide on return

                        } else { //if the form is valid
                            $('#' + paxnr + '.passactive').hide();
                            $('#' + paxnr + '.passsummary').html(data).show().removeClass("noshow");

                            var goToNextPassenger = function () {
                                var passportVal = $('#ShowEnterPassportDetails').val() ? "Yes" : "No";
                                $('.passportProvided').text(passportVal);

                                if (paxnr < noOfPax) {
                                    thisModule.displayAdditionalPassengers(paxnr);
                                } else {
                                    $("html, body").animate({ scrollTop: $('#' + paxnr + '.passsummary').offset().top }, 'slow', 'swing', function () { });
                                }

                                thisModule.bypassContinue(paxnr, thisModule.enableContinue);

                                beBasket.updateBasket();
                            }

                            if (paxnr == 1) {
                                var gdprContainer = $('#gdpr-content-container'),
                                    gdprBookingEngineForm = $('#gdpr-form'),
                                    gdprJourney = gdprBookingEngineForm.find("#gdprJourney").val();
                                
                                gdpr.display({
                                    container: gdprContainer,
                                    product: "Booking Engine",
                                    journey: gdprJourney,
                                    continueCallback: function () {
                                        goToNextPassenger();
                                        gdprBookingEngineForm.slideUp();
                                        gdprContainer.empty();
                                    },
                                    gdprFormLoadCallback: function () {
                                        gdprBookingEngineForm.show();
                                        $("html, body").animate({ scrollTop: gdprBookingEngineForm.offset().top - 100 }, "slow", "swing");
                                    },
                                    showSubmitLoader: true,
                                    continueImmediately: true
                                });
                            } else {
                                goToNextPassenger();
                            }
                        }

                        return null;
                    });

                    request.fail(function (jqXhr, textStatus) {
                        console.log(jqXhr);

                        var errorpage = $('#errorurl').val();
                        window.location.replace(errorpage);
                    });

                    request.always(function () {
                        loadingDialog.close();
                    });
                } else {
                    event.preventDefault();
                    slideToErrorSummary(paxnr);
                    loadingDialog.close();
                }
            });

            function getAgePassenger1() {
                var age = -1;
                var date = $("#dobYear1").val() + "-" + $("#dobMonth1").val() + "-" + $("#dobDay1").val();

                if (moment(date, ["YYYY-M-D"], true).isValid()) {
                    var today = new Date();
                    var birthDate = new Date(date);
                    age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();

                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    }
                }

                return age;
            }

            // Adobe
            // Lead passenger ONLY
            $(document).on("change", '[id*="SelectedTitle1"]', function () {
                var selectedTitle = $(this).val();
                AdlAddUpdateItem("title", selectedTitle);
            });

            $(document).on("click", '[id*="post1"]', function () {
                AdlAddUpdateItem("contactPreference", "Post");
                localStorage.setItem("contactPreference", "Post");
            });

            $(document).on("change", '[id*="email1"]', function () {
                AdlAddUpdateItem("contactPreference", "Email");
                localStorage.setItem("contactPreference", "Email");
            });

            $(document).on("change", '[id*="InsuranceOptedIn1"]', function () {
                AdlAddUpdateItem("travelInsurance", "Yes");
                localStorage.setItem("travelInsurance", "Yes");
            });

            $(document).on("change", '[id*="InsuranceOptedOut1"]', function () {
                AdlAddUpdateItem("travelInsurance", "No");
                localStorage.setItem("travelInsurance", "No");
            });

            $(document).on("change", '[id*="AssistanceRequiredYes1"]', function () {
                AdlAddUpdateItem("assistanceRequired", "Yes");
                localStorage.setItem("assistanceRequired", "Yes");
            });

            $(document).on("change", '[id*="AssistanceRequiredNo1"]', function () {
                AdlAddUpdateItem("assistanceRequired", "No");
                localStorage.setItem("assistanceRequired", "No");
            });

            $(document).on("change", '[id*="MedicalConditionYes1"]', function () {
                AdlAddUpdateItem("medicalCondition", "Yes");
                localStorage.setItem("medicalCondition", "Yes");
            });

            $(document).on("change", '[id*="MedicalConditionNo1"]', function () {
                AdlAddUpdateItem("medicalCondition", "No");
                localStorage.setItem("medicalCondition", "No");
            });

            $(document).on("change", '[id*="MedicalCondition1"]', function () {
                AdlAddUpdateItem("medicalCondition", "Don't Know");
                localStorage.setItem("medicalCondition", "Don't Know");
            });

            $(document).ready(function () {
                function adlLeadPassDetails() {
                    util.satelliteTrack("virtualPageViewTBJ");

                    //after the tracking call set previous page name to this value
                    //set a timeout to prevent it getting set before it's been read
                    //also add it to local storage so that a page change picks up the correct value
                    setTimeout(function () {
                        var prevpage = localStorage.getItem("previousPageName");

                        if (!thisModule.isNullUndefEmpty(prevpage)) {
                            AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                        }

                        localStorage.setItem("previousPageName", "travel|purchase|passengerdetails|leadpassenger");
                    }, 999);
                };

                clearTimeout(VPVtimer);
                VPVtimer = setTimeout(adlLeadPassDetails, 250);

                if ($('[id*="SelectedTitle1"]').is(':visible')) {
                    if ($('label[for="post1"]').is(':visible')) {
                        if ($('[id*="post1"]').is(':checked')) {
                            AdlAddUpdateItem("contactPreference", "Post");
                            localStorage.setItem("contactPreference", "Post");
                        } else if ($('[id*="email1"]').is(':checked')) {
                            AdlAddUpdateItem("contactPreference", "Email");
                            localStorage.setItem("contactPreference", "Email");
                        } else {
                            AdlAddUpdateItem("contactPreference", "None selected");
                            localStorage.setItem("contactPreference", "None selected");
                        }
                    } else {
                        AdlAddUpdateItem("contactPreference", "Not Offered");
                        localStorage.setItem("contactPreference", "Not Offered");
                    }

                    if ($('label[for="InsuranceOptedIn1"]').is(':visible')) {
                        if ($('[id*="InsuranceOptedIn1"]').is(':checked')) {
                            AdlAddUpdateItem("travelInsurance", "Yes");
                            localStorage.setItem("travelInsurance", "Yes");
                        } else if ($('[id*="InsuranceOptedOut1"]').is(':checked')) {
                            AdlAddUpdateItem("travelInsurance", "No");
                            localStorage.setItem("travelInsurance", "No");
                        } else {
                            AdlAddUpdateItem("travelInsurance", "None selected");
                            localStorage.setItem("travelInsurance", "None selected");
                        }
                    } else {
                        AdlAddUpdateItem("travelInsurance", "Not Offered");
                        localStorage.setItem("travelInsurance", "Not Offered");
                    }

                    if ($('label[for="AssistanceRequiredYes1"]').is(':visible')) {
                        if ($('[id*="AssistanceRequiredYes1"]').is(':checked')) {
                            AdlAddUpdateItem("assistanceRequired", "Yes");
                            localStorage.setItem("assistanceRequired", "Yes");
                        } else if ($('[id*="AssistanceRequiredNo1"]').is(':checked')) {
                            AdlAddUpdateItem("assistanceRequired", "No");
                            localStorage.setItem("assistanceRequired", "No");
                        } else {
                            AdlAddUpdateItem("assistanceRequired", "None selected");
                            localStorage.setItem("assistanceRequired", "None selected");
                        }
                    } else {
                        AdlAddUpdateItem("assistanceRequired", "Not Offered");
                        localStorage.setItem("assistanceRequired", "Not Offered");
                    }

                    if ($('label[for="MedicalConditionYes1"]').is(':visible')) {
                        if ($('[id*="MedicalConditionYes1"]').is(':checked')) {
                            AdlAddUpdateItem("medicalCondition", "Yes");
                            localStorage.setItem("medicalCondition", "Yes");
                        } else if ($('[id*="MedicalConditionNo1"]').is(':checked')) {
                            AdlAddUpdateItem("medicalCondition", "No");
                            localStorage.setItem("medicalCondition", "No");
                        } else if ($('[id*="MedicalCondition1"]').is(':checked')) {
                            AdlAddUpdateItem("medicalCondition", "Don't Know");
                            localStorage.setItem("medicalCondition", "Don't Know");
                        } else {
                            AdlAddUpdateItem("medicalCondition", "None selected");
                            localStorage.setItem("medicalCondition", "None selected");
                        }
                    } else {
                        AdlAddUpdateItem("medicalCondition", "Not offered");
                        localStorage.setItem("medicalCondition", "Not offered");
                    }
                }
            });

            //Copy error validation class to containing div.
            function slideToErrorSummary(id) {
                $(".elementHolder").each(function () {
                    if ($(this).find("input, select, .DOBWrapper").hasClass("input-validation-error")) {
                        $(this).addClass('errorHolder');
                    }
                });

                $("html, body").animate({
                    scrollTop: $("#valsummary" + id).offset().top - ($('#header').height() + 16)
                }, 'slow', 'swing');
            }

            //Amend pass details
            $('.passsummary').on("click", ".amend", function (event) {
                event.preventDefault();

                var passNo = $(this).attr('data-passid'),
                    gdprForm = $('#gdpr-form'),
                    gdprVisible = gdprForm.is(':visible');
                $('.validation-summary-errors').hide();

                if (parseInt(passNo) === 1 && gdprVisible) {
                    gdprForm.slideUp();
                    gdprForm.find('#gdpr-content-container').empty();
                }                    

                $('#' + passNo + '.passactive').slideDown("slow", function () {
                    $('select:visible').each(function () {
                        $(this).SumoSelect();
                        var test = $(this).attr('tabindex');
                        $(this).next('.SlectBox').attr('tabindex', test);
                    });

                    $('#' + passNo + '.passsummary').slideUp("slow", function () {
                        $('.passactive:not(#' + passNo + '.passactive)').hide();
                        $("html, body").animate({ scrollTop: $('#' + passNo + '.passactive').offset().top }, 'slow', 'swing');
                    });
                });

                var paxnr = $('#ActivePaxNumber').val();
                if ($('#' + paxnr + '.passsummary').text().trim().length > 10) {
                    $('#' + paxnr + '.passsummary').show();
                } else {
                    $('#' + paxnr + '.nopassdata').removeClass('noshow');
                    $('#' + paxnr + '.nopassdata').show();
                }
                $('#ActivePaxNumber').val(passNo);
            });

            //On click of Continue
            $('#passDetailsContinue').click(function () {
                AdlAddUpdateItem("BookingJourneyStep", "review");
            });

            //On entering any input field
            $('input').focus(function () {
                AdlAddUpdateItem("LastFieldInteraction", this.name);
                util.satelliteTrack("form field interaction");
            });

            //LookUpAddress Click
            $('.FindAddressBtn').click(function (event) {
                event.preventDefault ? event.preventDefault() : event.returnValue = false;
                var paxNo = $('#ActivePaxNumber').val(),
                    postCode = $('#PostCodep' + paxNo).val();
                thisModule.getAddressSummaries(paxNo, postCode);
            });

            //Select an address from dropdown
            $('.AddressSelect').on('change', function () {
                thisModule.getFormattedAddress($(this).val());
            });

            //Change Address Click
            $('.EditCompletedAddress').on("click", function () {
                var paxno = $('#ActivePaxNumber').val();
                $('#AddressPicker' + paxno + ' .FindAddressBtn').parent('.btn-group').removeClass('spinner');
                $("#EditCompletedAddressLink" + paxno).hide();
                $("#AddressPicker" + paxno).show(250);
                $("#dvLookUpAddr" + paxno).show();
                $('#AddressPicker' + paxno + ' .FindAddressBtn').show();
                $("#AddressPostCodeErrorText").hide();
            });

            //Enter Address Manually
            $('.ManualAddress').on("click", function () {
                openManualAddressPopUp();
            });

            //Add Address from dialog-Manual Button Click
            $('.AddManualAddress').on("click", function () {

                var errors = $('.checkout-manual-address :invalid');
                if (!errors || errors.length === 0) {

                    var addressOk = true;
                    var paxno = $('#ActivePaxNumber').val();
                    //check mandatory fields
                    var namenumber = $('#AddrLn1p' + paxno).val().trim();
                    var street = $('#AddrLn2p' + paxno).val().trim();
                    var town = $('#AddrTownp' + paxno).val().trim();
                    var county = $('#AddrCountyp' + paxno).val().trim();
                    var postcode = $('#AddrPostCodep' + paxno).val().trim();

                    postcode = postcode.replace(/\s+/g, '').toUpperCase();

                    $('#AddrPostCodep' + paxno).val(postcode);

                    if (thisModule.isNullUndefEmpty(namenumber) || thisModule.isNullUndefEmpty(town) || thisModule.isNullUndefEmpty(county) || thisModule.isNullUndefEmpty(postcode)) {
                        addressOk = false;
                    }

                    if (addressOk == false) {
                        $('#ManualAddressHeader' + paxno).text('Please complete all mandatory fields');
                        $('#ManualAddressHeader' + paxno).addClass('mandatory');
                    } else {
                        // check to see if a valid postcode is entered
                        if (!postcodeRegex.test(postcode)) {
                            $('#ManualAddressHeader' + paxno).text('Please enter a valid postcode');
                            $('#ManualAddressHeader' + paxno).addClass('mandatory');
                            $('#AddrPostCodep' + paxno).select();
                        } else {
                            setSelectedAddressText(true, paxno);
                            currentDialog.close();
                        }
                    }
                }
            });
      
            function openManualAddressPopUp() {
                var paxno = $('#ActivePaxNumber').val();

                //if postcode has been entered update postcode in popup if empty
                var postcodeElementValue = $('#AddrPostCodep' + paxno).val();
                if (postcodeElementValue) {
                    var postcodePopUp = $('#AddrPostCodep' + paxno).val().trim();
                }
                var postcode = $('#PostCodep' + paxno).val().trim();
                postcode = postcode.replace(/\s+/g, '').toUpperCase();

                if (!thisModule.isNullUndefEmpty(postcode)) {
                    if (thisModule.postcodeRegexTest(postcode)) {
                        if (thisModule.isNullUndefEmpty(postcodePopUp)) {
                            $('#AddrPostCodep' + paxno).val(postcode);
                        }
                    }
                }

                var content = $("#dialog-manualAddress" + paxno);
                content.find('#ManualAddressHeader' + paxno).remove(); // remove header as not needed for this dialog. not sure if used elsewhere              
                currentDialog = dialog.show('Enter your address below', content, {}, true, ["checkout-manual-address"]);
                content.show();
            }

            // Read a page's GET URL variables and return them as an associative array.
            function getUrlVars() {
                var vars = [], hash;
                var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

                for (var i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split('=');
                    vars.push(hash[0]);
                    vars[hash[0]] = hash[1];
                }

                return vars;
            }

            //On load of page check for querystring and make the respective summary sesssion active
            var passid = getUrlVars()["id"];

            if (!thisModule.isNullUndefEmpty(passid)) {
                $('#' + passid + '.passactive').show();
                $('#' + passid + '.passsummary').hide();
                $('#ActivePaxNumber').val(passid);
            }

            //DOB Validation Section
            var validateOnLoad = ($('.validation-summary-errors').length >= 1) ? true : false;

            //Trade agent, set defaults
            if ($('#IsAuthenticatedTradeAgent').val() === "True") {
                var paxnr = $('#ActivePaxNumber').val();
                //Ignore all fields with ignore class (if no passport entered).
                //$("#passdet" + paxnr).validate({
                //    ignore: ".ignorePass"
                //});

                $('.IssueExpiryHolder input').on('focus', function () {
                    var custiss = "cust_issueDate" + paxnr;
                    validationWorker(custiss, '', '0', true);
                    var custex = "cust_expiryDate" + paxnr;
                    validationWorker(custex, '', '0', true);
                    checkIssueExpiryDates("#issue");
                    checkIssueExpiryDates("#expiry");
                });
            }

            //reset DOB fields
            $('.dateConstituent').on('focus', function () {
                var paxnr = $('#ActivePaxNumber').val();
                var custdob = "cust_dob" + paxnr;
                validationWorker(custdob, '', '0', true);
            });

            //set up the date check
            $('input[type = text]:not(.dateConstituent), input[type = tel], input[type = email]').on('focus', function () {
                validateDobFields(false);

                //validate passport date fields for trade agents.
                if ($('#IsAuthenticatedTradeAgent').val() === "True") {
                    validateIssueExpiryFields(false, "cust_issueDate", "#issue");
                    validateIssueExpiryFields(false, "cust_expiryDate", "#expiry");
                    checkIssueExpiryDates("#issue");
                    checkIssueExpiryDates("#expiry");
                }

                var age = getAgePassenger1();
                if (age != -1) {
                    AdlAddUpdateItem("age", age.toString());
                }
            });

            function checkIssueExpiryDates(issueOrExpiry) {
                var paxnr = $('#ActivePaxNumber').val();
                $(issueOrExpiry + 'DateVal' + paxnr).hide();

                var dvalue = $(issueOrExpiry + "DateDay" + paxnr).val();
                var mvalue = $(issueOrExpiry + "DateMonth" + paxnr).val();
                var yvalue = $(issueOrExpiry + "DateYear" + paxnr).val();
                var date = yvalue + "-" + mvalue + "-" + dvalue;

                if (date != "--") {
                    $(issueOrExpiry + 'Date' + paxnr).val(moment(date, 'YYYY-MM-DD').format("DD/MM/YYYY"));
                } else {
                    $(issueOrExpiry + 'Date' + paxnr).val("01/01/0001");
                }
            };

            // validation worker - takes the id of the element to add remove classes and two values to compare.
            function validationWorker(id, input_value, test_value, reset, content_type, min_length, max_length) {
                var alphaCharsRE = /^[a-zA-Z- ]*$/; //a-z, hyphen and space
                var numericCharsRE = /^[0-9]*$/; //0-9
                var alphaNumericCharsRE = /^[a-zA-Z0-9- ]*$/; //a-z, 0-9 hyphen and space
                var emailRE = /\S+@\S+\.\S+/; //nb: only tests anything@anything.anything
                var paxnr = $('#ActivePaxNumber').val();

                if (reset) {
                    $('#' + id).removeClass("input-validation-error");
                    if (id === "cust_dob" + paxnr) { $('#dobDay' + paxnr).closest('.element').removeClass('valid'); }
                    if (id === "cust_issueDate" + paxnr) { $('#issueDateDay' + paxnr).closest('.element').removeClass('valid'); }
                    if (id === "cust_expiryDate" + paxnr) { $('#expiryDateDay' + paxnr).closest('.element').removeClass('valid'); }
                    return null;
                }

                if (input_value == test_value) {
                    $('#' + id).removeClass("valid").addClass("input-validation-error");
                    if (id === "cust_dob" + paxnr) {
                        $('#dobDay' + paxnr).closest('.element').removeClass('valid');
                        $('#dobval' + paxnr).show();
                    }
                    if (id === "cust_issueDate" + paxnr) {
                        $('#cust_issueDate' + id).removeClass("valid").addClass("input-validation-error");
                        $('#issueDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#issueDateVal' + paxnr).show();
                    }
                    if (id === "cust_expiryDate" + paxnr) {
                        $('#cust_expiryDate' + id).removeClass("valid").addClass("input-validation-error");
                        $('#expiryDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#expiryDateVal' + paxnr).show();
                    }
                    return null;
                }

                var minInputLength = (min_length == undefined) ? 1 : min_length;
                if (minInputLength > input_value.length) {
                    $('#' + id).removeClass("valid").addClass("input-validation-error");
                    if (id === "cust_dob" + paxnr) {
                        $('#dobDay' + paxnr).closest('.element').removeClass('valid');
                        $('#dobval' + paxnr).show();
                    }
                    if (id === "cust_issueDate" + paxnr) {
                        $('#issueDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#issueDateVal' + paxnr).show();
                    }
                    if (id === "cust_expiryDate" + paxnr) {
                        $('#expiryDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#expiryDateVal' + paxnr).show();
                    }
                    return null;
                }

                var maxInputLength = (max_length == undefined) ? 9999 : max_length;
                if (maxInputLength < input_value.length) {
                    $('#' + id).removeClass("valid").addClass("input-validation-error");
                    if (id === "cust_dob" + paxnr) {
                        $('#dobDay' + paxnr).closest('.element').removeClass('valid');
                        $('#dobval' + paxnr).show();
                    }
                    if (id === "cust_issueDate" + paxnr) {
                        $('#issueDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#issueDateVal' + paxnr).show();
                    }
                    if (id === "cust_expiryDate" + paxnr) {
                        $('#expiryDateDay' + paxnr).closest('.element').removeClass('valid');
                        $('#expiryDateVal' + paxnr).show();
                    }
                    return null;
                }

                if (content_type != undefined) {
                    var str = input_value;
                    var passFail = true;

                    switch (content_type) {
                        case "alpha":
                            passFail = alphaCharsRE.test(str);
                            break;
                        case "numeric":
                            passFail = numericCharsRE.test(str);
                            break;
                        case "alphanumeric":
                            passFail = alphaNumericCharsRE.test(str);
                            break;
                        case "email":
                            passFail = emailRE.test(str);
                            break;
                        default:
                            passFail = true;
                    }

                    if (passFail == false) {
                        $('#' + id).removeClass("valid").addClass("input-validation-error");
                        $('#dobDay' + paxnr).closest('.element').removeClass('valid');
                        $('#dobval' + paxnr).show();
                        return null;
                    }
                }

                // if it gets to here it passed the validation rules
                $('#' + id).removeClass("input-validation-error").addClass("valid");
                $('#dobval' + paxnr).hide();
                $('#dobDay' + paxnr).closest('.element').addClass('valid');
            }

            if (validateOnLoad) {
                validateDobFields(true);
            }

            $('.DOBWrapper').on('keyup', function (e) {
                var targetelem = e.target;
                var maxLength = parseInt($(targetelem).attr('maxLength'), 10);
                var myLength = $(targetelem).val().length;

                if (myLength >= maxLength) {
                    var next = $(targetelem).parent();

                    while (next = $(next).next('.DOBHolder')) {
                        $(next).find('input').focus();
                        break;
                    }
                }
            });

            function validateIssueExpiryFields(forceValidate, wrapperId, issueOrExpiry) {
                var paxnr = $('#ActivePaxNumber').val();
                var custWrapId = wrapperId + paxnr;
                $(issueOrExpiry + 'DateVal' + paxnr).hide();

                var dvalue = $(issueOrExpiry + "DateDay" + paxnr).val();
                dvalue = (dvalue != "") ? parseInt(dvalue) : dvalue;

                var mvalue = $(issueOrExpiry + "DateMonth" + paxnr).val();
                mvalue = (mvalue != "") ? parseInt(mvalue) : mvalue;

                var yvalue = $(issueOrExpiry + "DateYear" + paxnr).val();
                var doValidate = (dvalue == "" && mvalue == "" && yvalue == "") ? '0' : '1';
                var date = yvalue + "-" + mvalue + "-" + dvalue;

                if (date == "--") {
                    //Just set a default
                    $(issueOrExpiry + 'Date' + paxnr).val("01/01/0001");
                    $(issueOrExpiry + 'DateVal' + paxnr).hide();
                } else {
                    if (doValidate == 1 || forceValidate) {
                        if (moment(date, ["YYYY-M-D"], true).isValid()) {
                            $(issueOrExpiry + 'DateVal' + paxnr).hide();
                            $(issueOrExpiry + 'Date' + paxnr).val(moment(date).format("DD/MM/YYYY"));
                        } else {
                            $(issueOrExpiry + 'DateVal' + paxnr).show();
                            $('#' + custWrapId).removeClass("valid").addClass("input-validation-error");
                        }
                    }
                }
            };

            //DOB field check all date inputs - make a function and fire when other fields are entered
            function validateDobFields(forceValidate) {
                var paxnr = $('#ActivePaxNumber').val();
                var custdob = "cust_dob" + paxnr;
                $('#dobval' + paxnr).hide();

                // check day
                var dvalue = $("#dobDay" + paxnr).val();
                dvalue = (dvalue != "") ? parseInt(dvalue) : dvalue;

                // check month DOB
                var mvalue = $("#dobMonth" + paxnr).val();
                mvalue = (mvalue != "") ? parseInt(mvalue) : mvalue;

                // check year
                var yvalue = $("#dobYear" + paxnr).val();
                var doValidate = (dvalue == "" && mvalue == "" && yvalue == "") ? '0' : '1';  // only validate if at least one date field has been completed

                if (doValidate == 1 || forceValidate) {
                    var date = yvalue + "-" + mvalue + "-" + dvalue;

                    if (moment(date, ["YYYY-M-D"], true).isValid()) {
                        $('#dobval' + paxnr).hide();

                        var passfail = (dvalue == "" || mvalue == "" || yvalue == "") ? '0' : '1';

                        validationWorker(custdob, passfail, '0');

                        // IF it passes first test CHECK PASSENGER AGE - 50 for lead passenger, otherwise 40
                        if (passfail == 1) {
                            var today = new Date();
                            var age = today.getFullYear() - yvalue;

                            if (today.getMonth() < (mvalue - 1) || (today.getMonth() == (mvalue - 1) && today.getDate() < dvalue)) {
                                age--;
                            }

                            var minAge = (paxnr == 1) ? 50 : 40;
                            var passfail2 = (age < minAge) ? '0' : '1';

                            if (passfail2 == 1) {
                                passfail2 = (age > 120) ? '0' : '1';
                            }

                            validationWorker(custdob, passfail2, '0');
                        }

                        $('#DateofBirth' + paxnr).val(moment(date, 'YYYY-MM-DD').format("DD/MM/YYYY"));
                    } else {
                        $('#dobval' + paxnr).show();
                        $('#' + custdob).removeClass("valid").addClass("input-validation-error");
                    }
                }
            };

            function IsDOBValid(paxnr) {
                validateDobFields(true);
                if ($('#dobval' + paxnr).is(':visible')) {
                    return false;
                }
                return true;
            }
            function IsIssueDateValid(paxnr) {
                validateIssueExpiryFields(true, "cust_issueDate", "#issue");
                if ($('#issueDateVal' + paxnr).is(':visible')) {
                    return false;
                }
                return true;
            }
            function IsExpiryDateValid(paxnr) {
                validateIssueExpiryFields(true, "cust_expiryDate", "#expiry");
                if ($('#expiryDateVal' + paxnr).is(':visible')) {
                    return false;
                }
                return true;
            }

            //Select an address from dropdown
            $('.helptext').on('click', function () {
                var id = $(this).data('helptext');
                $('#' + id).toggleClass('noshow');
            });

            //Call SUMO
            $('select:visible').each(function () {
                $(this).SumoSelect();
                var test = $(this).attr('tabindex');
                $(this).next('.SlectBox').attr('tabindex', test);
            });            

            //Remove Error from Holder if valid.
            $('form').on('keyup', 'input', function () {
                if ($(this).hasClass("valid")) {
                    $(this).closest('.elementHolder').removeClass('errorHolder');
                };
            });

            $('form').on('click', '.optWrapper', function () {
                if ($(this).closest('.element').find('select').hasClass("valid")) {
                    $(this).closest('.element').addClass('valid');
                } else {
                    $(this).closest('.element').removeClass('valid');
                };

                if ($(this).closest('.element').find('select').hasClass("input-validation-error")) {
                    $(this).closest('.elementHolder').addClass('errorHolder');
                } else {
                    $(this).closest('.elementHolder').removeClass('errorHolder');
                };
            });

            $('input').each(function () {
                if ($(this).hasClass("valid")) {
                    $(this).closest('.element').addClass('valid');
                }
            });

            $('input').blur(function () {
                if (!$(this).parent().hasClass("DOBHolder")) {
                    if ($(this).hasClass("valid")) {
                        $(this).closest('.element').addClass('valid');
                    } else {
                        $(this).closest('.element').removeClass('valid');
                    }
                }

                //Check if there is an error
                if ($(this).hasClass("input-validation-error")) {
                    $(this).closest('.elementHolder').addClass('errorHolder');
                } else {
                    $(this).closest('.elementHolder').removeClass('errorHolder');
                }
            });

            window.loadedModules("BookingEngine/app-Passdetails");
        }
    }
});
